import 'animate.css'
import './assets/css/main.css'
import './assets/css/tailwind.include.css'
import './utils/plugins/ripple.js'
import './utils/plugins/swipper.js'

import { Commons } from './utils/commons'
import { Translate } from './utils/translate.js'
import { ColorTheme } from './utils/colorTheme.js'
import { Events } from './utils/events'
import { NotificationUtils } from './utils/notificationsUtils'
import { Chat } from './utils/chat.js'
import { Countries } from './utils/countries.js'
import { QuickStorage } from './utils/quickStorage.js'
import { WorkerUtils } from './service-worker/workerUtils.js'
import { Network } from './utils/network.js'

Events.init()
Events.initKeepWorkerAlivePing()
QuickStorage.init()
Translate.init()
ColorTheme.init()
Chat.init()
WorkerUtils.init()
NotificationUtils.init()
Network.initNetworkStateListener()

import { createApp } from 'vue'
import App from './App.vue'
import AppSubscription from './AppSubscription.vue'
import AppGiftCard from './AppGiftCard.vue'
import router from './router'

let app
try {
  let isSubscription = false
  let isGiftCard = false
  if (/netflix/i.test(window.location.href)) isSubscription = true
  if (/prime-video/i.test(window.location.href)) isSubscription = true
  if (/disney-plus/i.test(window.location.href)) isSubscription = true
  if (/crunchyroll/i.test(window.location.href)) isSubscription = true
  if (/spotify/i.test(window.location.href)) isSubscription = true
  if (/nordvpn/i.test(window.location.href)) isSubscription = true
  if (/privatevpn/i.test(window.location.href)) isSubscription = true
  if (/cyberghost/i.test(window.location.href)) isSubscription = true
  if (/adn/i.test(window.location.href)) isSubscription = true
  if (/giftCard/i.test(window.location.href)) isGiftCard = true

  if (isSubscription) app = createApp(AppSubscription)
  else if (isGiftCard) app = createApp(AppGiftCard)
  else app = createApp(App)

  app.use(router)
} catch (error) {
  app = createApp(App)
  app.use(router)
}

app.config.globalProperties.$Commons = Commons
app.config.globalProperties.$QuickStorage = QuickStorage
app.config.globalProperties.$Countries = Countries
app.config.globalProperties.$NotificationUtils = NotificationUtils
app.config.globalProperties.$Events = Events
app.config.globalProperties.$Chat = Chat
app.config.globalProperties.$Translate = Translate
app.config.globalProperties.$ColorTheme = ColorTheme
app.config.globalProperties.$t = Translate.$t
try {
  app.config.globalProperties.$IsIframe = window.isIframe
} catch (error) {
  app.config.globalProperties.$IsIframe = null
}

app.mount('#app')
